module.exports = __webpack_public_path__ + "img/ta-ny-rightTitleBg02.15c1f74b.png";